var map = {
	"./": 62306,
	"./App": 5672,
	"./App.css": 44050,
	"./App.test": 49089,
	"./App.test.tsx": 49089,
	"./App.tsx": 5672,
	"./assets/image1.webp": 45506,
	"./assets/image10.webp": 62398,
	"./assets/image2.webp": 53155,
	"./assets/image3.webp": 22752,
	"./assets/image4.webp": 17881,
	"./assets/image5.webp": 60094,
	"./assets/image6.webp": 48735,
	"./assets/image7.webp": 58492,
	"./assets/image8.webp": 40789,
	"./assets/image9.webp": 78922,
	"./components/cards/book-card": 40690,
	"./components/cards/book-card.tsx": 40690,
	"./components/header/header": 2120,
	"./components/header/header.css": 81555,
	"./components/header/header.tsx": 2120,
	"./components/loaders": 93231,
	"./components/loaders.tsx": 93231,
	"./components/logo": 68316,
	"./components/logo.tsx": 68316,
	"./components/menu": 90027,
	"./components/menu.tsx": 90027,
	"./components/page-content/page-content": 30168,
	"./components/page-content/page-content.css": 87435,
	"./components/page-content/page-content.tsx": 30168,
	"./components/search-bar/search-bar": 7788,
	"./components/search-bar/search-bar.css": 12169,
	"./components/search-bar/search-bar.tsx": 7788,
	"./contexts/graphql-context": 71920,
	"./contexts/graphql-context.tsx": 71920,
	"./contexts/routing-context": 75541,
	"./contexts/routing-context.tsx": 75541,
	"./contexts/theme-context": 60590,
	"./contexts/theme-context.tsx": 60590,
	"./hooks/books": 48767,
	"./hooks/books.ts": 48767,
	"./hooks/readling-list": 76474,
	"./hooks/readling-list.ts": 76474,
	"./hooks/search": 2049,
	"./hooks/search.ts": 2049,
	"./index": 62306,
	"./index.css": 59555,
	"./index.tsx": 62306,
	"./interfaces/book": 5726,
	"./interfaces/book.ts": 5726,
	"./layouts/grid-view": 55888,
	"./layouts/grid-view.tsx": 55888,
	"./pages/home": 27810,
	"./pages/home.tsx": 27810,
	"./pages/reading-list": 80326,
	"./pages/reading-list.tsx": 80326,
	"./react-app-env.d": 55059,
	"./react-app-env.d.ts": 55059,
	"./reportWebVitals": 16469,
	"./reportWebVitals.ts": 16469,
	"./setupTests": 35374,
	"./setupTests.ts": 35374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;